<template>
    <div>
        <input type="checkbox" v-model="selected" @change="onCheckChange">
    </div>
</template>

<script>

import ValueChecker from "../../services/ValueChecker";

export default {
    props: {
        eventBus: {
            type: Object,
        },
        columnIndex: {
            Type: Number
        },
        config: {
            Type: Object
        },
        row: {
            Type: Object
        }
    },
    data() {
        return {
            selected: false
        };
    },
    mounted() {
        this.validate();
        this.mountEvents();
    },
    methods: {
        onCheckChange: function () {
            this.emitSelected(this.selected);
        },
        componentIndex() {
            return this.config['index'];
        },
        defaultBindEvents() {
            let parentComponentIndex = this.config['parentComponentIndex'];

            if (ValueChecker.isUndefinedOrNull(parentComponentIndex)) {
                return [];
            }

            return [{
                name: 'selectAll',
                componentIndex: parentComponentIndex,
            }, {
                name: 'deselectAll',
                componentIndex: parentComponentIndex,
            }, {
                name: 'setRowSelected',
                componentIndex: parentComponentIndex,
            }];
        },
        deselectAll() {
            this.selected = false;
        },
        emitSelected(selected) {
            let eventName = selected ? `${this.componentIndex()}:rowSelected` : `${this.componentIndex()}:rowDeselected`;
            this.eventBus.$emit(eventName, this.row, this.identityField());
        },
        identityField() {
            return this.config['identityField'];
        },
        mountEvents() {
            let eventManagerService = this.eventBus.getEventManager();
            eventManagerService.bindEvents(this.defaultBindEvents(), this);

            this.eventBus.$emit(this.config.index + ':checkRowIsSelected', this.row, this.identityField());
        },
        selectAll() {
            this.selected = true;
        },
        setRowSelected(rowSelected, selectedRow) {
            if (!rowSelected) {
                return;
            }

            let itsMe = selectedRow && (this.row[this.identityField()] === selectedRow[this.identityField()]);

            if (!itsMe) {
                return;
            }

            this.selected = rowSelected;
        },
        validate() {
            let identityField = this.identityField();

            if (ValueChecker.isUndefinedOrNull(this.row[identityField])) {
                throw `Invalid config identity field "${identityField}" not found in row`;
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// SelectRowComponent.vue?4dd71f36